<template>
  <div class="increment-rail">
    <div class="increment-rail__eyebrow">{{ phase === 'bidding' ? 'Increment' : 'Drop size' }}</div>
    <div class="increment-rail__grid" :style="{ gridTemplateRows: `repeat(${steps.length}, 1fr)` }">
      <IncrementButton
        v-for="amount in steps"
        :key="amount"
        :amount="amount"
        :sign="phase === 'bidding' ? '+' : '-'"
        :tone="phase === 'bidding' ? 'primary' : 'info'"
        :density="density"
        :active="amount === selectedStep"
        :hint="amount === selectedStep ? 'Current' : null"
        :disabled="disabled"
        @click="emit('select', amount)"
      />
    </div>
  </div>
</template>

<script setup>
import IncrementButton from '../IncrementButton/IncrementButton.vue';

// The price ladder down the right-hand edge.
//
// It read live bidding state through a composable, chose its own ladder from
// it, and called the runtime directly when a step was tapped. All three are the
// application's now: it reports `select` and is told which step is set.
//
// The two phases are the whole shape of the thing. Once bids are coming in the
// ladder steps the increment UP in the brand mint; while the auctioneer is
// still fishing for an opening bid it drops the ASK, and every step is blue and
// signed minus so the direction cannot be misread mid-sale.
defineOptions({ name: 'IncrementRail' });

defineProps({
  // The ladder, largest last. The two phases want different rungs, and which
  // rungs a house uses is its own convention.
  steps: { type: Array, default: () => [25, 50, 100, 250, 500, 1000, 2500, 5000] },
  // The step currently set on the lot. Null highlights nothing.
  selectedStep: { type: Number, default: null },
  // bidding | asking
  phase: { type: String, default: 'bidding', validator: (value) => ['bidding', 'asking'].includes(value) },
  // comfortable | compact — the console runs compact.
  density: { type: String, default: 'compact', validator: (value) => ['comfortable', 'compact'].includes(value) },
  // The lot is finalized, or a change is in flight.
  disabled: { type: Boolean, default: false },
});

const emit = defineEmits(['select']);
</script>

<style scoped>
.increment-rail {
  flex: 0 0 207px;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: var(--p-increment-rail-gap);
}

.increment-rail__eyebrow {
  text-transform: uppercase;
  font-size: var(--p-increment-rail-eyebrow-font-size);
  font-weight: var(--p-increment-rail-eyebrow-font-weight);
  letter-spacing: var(--p-increment-rail-eyebrow-letter-spacing);
  color: var(--p-increment-rail-eyebrow-color);
  padding: var(--p-increment-rail-eyebrow-padding);
}

.increment-rail__grid {
  flex: 1;
  min-height: 0;
  display: grid;
  gap: var(--p-increment-rail-grid-gap);
}
</style>
